import React, { useEffect, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'

import reserveApi from '../../utils/axios'
import { ButtonLink } from '../utils/Button'

const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
}

export const FacilityGroupIndex = ({ match }) => {
  const stateFilter = useMemo(() => STATES[match.params.state] && match.params.state, [match])
  const [facilityGroups, setFacilityGroups] = useState([])

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/marketing/facility_groups',
      params: { state: stateFilter }
    }).then(response => {
      setFacilityGroups(response.data)
    })
  }, [stateFilter])

  return (
    <div>
      <div className="prose-xl">
        {stateFilter && <h2>{STATES[stateFilter]}</h2>}
        {!stateFilter && <p>
          WanderingLabs supports numerous parks, campgrounds, cabin rentals, lookout towers across the entire United
          States and Canada. Including at many of the most popular state parks and federal locations.
        </p>}

        <p></p>
      </div>
      <ul>
        {facilityGroups.map(facilityGroup => (
          <li key={facilityGroup.id} className="py-4 border-t-2 border-gray-300 flex items-start">
            <div className="flex-grow">
              <div className="text-xl font-semibold">
                <Link to={`/explore/${facilityGroup.slug}`}>{facilityGroup.name}</Link>
              </div>
              <p className="mt-2">
                Monitoring {facilityGroup.sites_count} campsites at {facilityGroup.facilities_count} different
                campgrounds
              </p>

              {facilityGroup.top_facilities && facilityGroup.top_facilities.length > 0 && (
                <p className="mt-2">
                  Popular:{' '}
                  {facilityGroup.top_facilities
                    .map(facility => (
                      <Link to={`/f/${facility.slug}`} key={facility.name}>
                        {facility.name}
                      </Link>
                    ))
                    .reduce((prev, curr) => [prev, ', ', curr])}
                </p>
              )}
            </div>
            <ButtonLink to={`/explore/${facilityGroup.slug}`} color="green" className="flex-none">
              Explore
            </ButtonLink>
          </li>
        ))}
      </ul>

      <div>
        <div className="mt-6 text-lg font-semibold">Explore campgrounds we support in different states:</div>
        <div className="flex flex-wrap">
          {Object.keys(STATES).map(state => (
            <div key={state} className="mr-2 mt-2">
              <ButtonLink to={`/explore/state/${state}`} className="px-4 text-sm">{state} {STATES[state]}</ButtonLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FacilityGroupIndex
